<template>
    <div class="visit-statistics-container">
        <div class="statistics-card">
            <div class="card-header">
                <h2>来访统计</h2>
                <div class="header-right">
                    <el-date-picker
                        v-model="searchDate"
                        type="date"
                        placeholder="年/月/日"
                        value-format="yyyy-MM-dd"
                        style="width: 180px"
                        clearable
                    ></el-date-picker>
                    <el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
                </div>
            </div>

            <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="custom-tabs">
                <el-tab-pane label="按天统计" name="day"></el-tab-pane>
                <el-tab-pane label="按月统计" name="month"></el-tab-pane>
                <el-tab-pane label="按人统计" name="person"></el-tab-pane>
            </el-tabs>

            <div v-if="activeTab === 'day'" class="tab-content">
                <div class="chart-wrapper">
                    <h4>近7天来访识别次数统计</h4>
                    <div ref="dayChart" style="width: 100%; height: 300px"></div>
                </div>

                <div class="fixed-table-container">
                    <el-table
                        :data="dayTableData"
                        v-loading="tableLoading"
                        :header-cell-style="fixedHeaderStyle"
                        :cell-style="fixedCellStyle"
                        :row-style="fixedRowStyle"
                        border
                        style="width: 100%"
                    >
                        <el-table-column prop="date" label="日期" width="160"></el-table-column>
                        <el-table-column prop="totalCount" label="总识别次数" width="160"></el-table-column>
                        <el-table-column prop="employeeCount" label="员工识别次数" width="180"></el-table-column>
                        <el-table-column prop="visitorCount" label="访客识别次数" width="180"></el-table-column>
                        <el-table-column prop="peakTime" label="高峰时段" width="180"></el-table-column>
                    </el-table>
                </div>

                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    layout="prev, pager, next"
                    :total="totalCount"
                    :page-size="pageSize"
                    align="center"
                    class="pagination"
                ></el-pagination>
            </div>

            <div v-if="activeTab === 'month'" class="tab-content">
                <div class="chart-wrapper">
                    <h4>本月来访识别次数统计</h4>
                    <div ref="monthChart" style="width: 100%; height: 300px"></div>
                </div>

                <div class="fixed-table-container">
                    <el-table
                        :data="monthTableData"
                        v-loading="tableLoading"
                        :header-cell-style="fixedHeaderStyle"
                        :cell-style="fixedCellStyle"
                        :row-style="fixedRowStyle"
                        border
                        style="width: 100%"
                    >
                        <el-table-column prop="month" label="月份" width="160"></el-table-column>
                        <el-table-column prop="totalCount" label="总识别次数" width="160"></el-table-column>
                        <el-table-column prop="employeeCount" label="员工识别次数" width="180"></el-table-column>
                        <el-table-column prop="visitorCount" label="访客识别次数" width="180"></el-table-column>
                    </el-table>
                </div>

                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    layout="prev, pager, next"
                    :total="totalCount"
                    :page-size="pageSize"
                    align="center"
                    class="pagination"
                ></el-pagination>
            </div>

            <div v-if="activeTab === 'person'" class="tab-content">
                <div class="chart-wrapper">
                    <h4>TOP10 来访次数最多人员</h4>
                    <div ref="personChart" style="width: 100%; height: 300px"></div>
                </div>

                <div class="fixed-table-container">
                    <el-table
                        :data="personTableData"
                        v-loading="tableLoading"
                        :header-cell-style="fixedHeaderStyle"
                        :cell-style="fixedCellStyle"
                        :row-style="fixedRowStyle"
                        border
                        style="width: 100%"
                    >
                        <el-table-column prop="name" label="姓名" width="100"></el-table-column>
                        <el-table-column prop="empNo" label="工号" width="120"></el-table-column>
                        <el-table-column prop="monthCount" label="本月识别次数" width="160"></el-table-column>
                        <el-table-column prop="firstTime" label="本月首次识别时间" width="220"></el-table-column>
                        <el-table-column prop="lastTime" label="本月末次识别时间" width="220"></el-table-column>
                    </el-table>
                </div>

                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    layout="prev, pager, next"
                    :total="totalCount"
                    :page-size="pageSize"
                    align="center"
                    class="pagination"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import { baseURL } from '@/utils/request.js';

export default {
    name: 'VisitStatistics',
    data() {
        return {
            activeTab: 'day',
            searchDate: '',
            tableLoading: false,
            pageSize: 10,
            currentPage: 1,
            totalCount: 0,

            dayChart: null,
            monthChart: null,
            personChart: null,

            dayTableData: [],
            monthTableData: [],
            personTableData: [
                { name: '张三', empNo: 'EMP-001', monthCount: 89, firstTime: '2026-03-01 08:05', lastTime: '2026-03-02 18:30' },
                { name: '李四', empNo: 'EMP-002', monthCount: 85, firstTime: '2026-03-01 08:10', lastTime: '2026-03-02 17:45' },
                { name: '王五', empNo: 'EMP-003', monthCount: 78, firstTime: '2026-03-01 08:15', lastTime: '2026-03-02 18:10' }
            ],

            fixedHeaderStyle: {
                'text-align': 'center',
                'font-size': '14px',
                'font-weight': '600',
                color: '#333',
                'background-color': '#f5f7fa',
                padding: '10px 0',
                border: '1px solid #ebeef5'
            },
            fixedCellStyle: {
                'text-align': 'center',
                'font-size': '14px',
                padding: '10px 0',
                border: '1px solid #ebeef5'
            }
        };
    },
    methods: {
        fixedRowStyle({ rowIndex }) {
            return rowIndex % 2 === 0 ? 'background-color: #ffffff;' : 'background-color: #f5f7fa;';
        },

        handleQuery() {
            this.currentPage = 1;
            this[`query${this.activeTab.charAt(0).toUpperCase() + this.activeTab.slice(1)}Data`]();
        },

        handleTabClick(tab) {
            this.activeTab = tab.name;
            this.$nextTick(() => {
                this[`render${tab.name.charAt(0).toUpperCase() + tab.name.slice(1)}Chart`]();
                this[`query${tab.name.charAt(0).toUpperCase() + tab.name.slice(1)}Data`]();
            });
        },

        handleSizeChange(val) {
            this.pageSize = val;
            this[`query${this.activeTab.charAt(0).toUpperCase() + this.activeTab.slice(1)}Data`]();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this[`query${this.activeTab.charAt(0).toUpperCase() + this.activeTab.slice(1)}Data`]();
        },

        renderDayChart() {
            if (!this.$refs.dayChart) return;
            this.dayChart = echarts.init(this.$refs.dayChart);
            // 修复：补充完整的7天访客数据，确保双柱显示
            const employeeData = [420, 480, 500, 460, 390, 0, 0];
            const visitorData = [95, 110, 105, 125, 30, 20, 0];
            this.dayChart.setOption({
                legend: { data: ['员工', '访客'], top: 0, right: 20 },
                grid: { left: '5%', right: '5%', bottom: '15%', containLabel: true },
                xAxis: {
                    type: 'category',
                    data: ['02-27', '02-28', '02-29', '03-01', '03-02', '03-03', '03-04'],
                    axisLabel: { interval: 0 }
                },
                yAxis: { type: 'value', max: 500 },
                series: [
                    {
                        name: '员工',
                        type: 'bar',
                        data: employeeData,
                        itemStyle: { color: '#406abb' },
                        // 新增：设置柱宽，避免柱子过宽
                        barWidth: '40%',
                        // 新增：柱子间距，适配双柱显示
                        barGap: '30%'
                    },
                    {
                        name: '访客',
                        type: 'bar',
                        data: visitorData,
                        itemStyle: { color: '#67c23a' },
                        barWidth: '40%'
                    }
                ]
            });
        },

        renderMonthChart() {
            if (!this.$refs.monthChart) return;
            this.monthChart = echarts.init(this.$refs.monthChart);
            this.monthChart.setOption({
                legend: { data: ['员工', '访客'], top: 0, right: 20 },
                grid: { left: '5%', right: '5%', bottom: '10%', containLabel: true },
                xAxis: { type: 'category', data: ['01月', '02月', '03月'] },
                yAxis: { type: 'value' },
                series: [
                    { name: '员工', type: 'bar', data: [12000, 13500, 4500], itemStyle: { color: '#406abb' }, barWidth: '40%' },
                    { name: '访客', type: 'bar', data: [2500, 2800, 800], itemStyle: { color: '#67c23a' }, barWidth: '40%' }
                ]
            });
        },

        renderPersonChart() {
            if (!this.$refs.personChart) return;
            this.personChart = echarts.init(this.$refs.personChart);
            this.personChart.setOption({
                legend: { data: ['员工', '访客'], top: 0, right: 20 },
                grid: { left: '5%', right: '5%', bottom: '15%', containLabel: true },
                xAxis: {
                    type: 'category',
                    data: ['张三', '李四', '王五', '赵六', '钱七', '孙八', '周九', '吴十', '郑十一', '冯十二'],
                    axisLabel: { rotate: 0 }
                },
                yAxis: { type: 'value', max: 4000 },
                series: [
                    {
                        name: '员工',
                        type: 'bar',
                        data: [400, 420, 410, 390, 430, 380, 370, 360, 350, 340],
                        itemStyle: { color: '#406abb' },
                        barWidth: '60%'
                    },
                    {
                        name: '访客',
                        type: 'line',
                        data: [2800, 3100, 2500, 2200, 3500, 2000, 1500, 1200, 1000, 900],
                        itemStyle: { color: '#67c23a' },
                        lineStyle: { color: '#67c23a', width: 2 },
                        symbol: 'circle',
                        symbolSize: 6
                    }
                ]
            });
        },

        queryDayData() {
            this.tableLoading = true;
            setTimeout(() => {
                this.dayTableData = [
                    { date: '2026-03-01', totalCount: 589, employeeCount: 456, visitorCount: 133, peakTime: '08:00-09:00' },
                    { date: '2026-03-02', totalCount: 425, employeeCount: 389, visitorCount: 36, peakTime: '08:10-09:10' },
                    { date: '2026-02-29', totalCount: 612, employeeCount: 498, visitorCount: 114, peakTime: '07:50-08:50' }
                ];
                this.totalCount = 3;
                this.tableLoading = false;
            }, 500);
        },

        queryMonthData() {
            this.tableLoading = true;
            setTimeout(() => {
                this.monthTableData = [
                    { month: '2026-01', totalCount: 15000, employeeCount: 12000, visitorCount: 3000 },
                    { month: '2026-02', totalCount: 16300, employeeCount: 13500, visitorCount: 2800 },
                    { month: '2026-03', totalCount: 5300, employeeCount: 4500, visitorCount: 800 }
                ];
                this.totalCount = 3;
                this.tableLoading = false;
            }, 500);
        },

        queryPersonData() {
            this.tableLoading = true;
            setTimeout(() => {
                this.personTableData = [
                    { name: '张三', empNo: 'EMP-001', monthCount: 89, firstTime: '2026-03-01 08:05', lastTime: '2026-03-02 18:30' },
                    { name: '李四', empNo: 'EMP-002', monthCount: 85, firstTime: '2026-03-01 08:10', lastTime: '2026-03-02 17:45' },
                    { name: '王五', empNo: 'EMP-003', monthCount: 78, firstTime: '2026-03-01 08:15', lastTime: '2026-03-02 18:10' }
                ];
                this.totalCount = 3;
                this.tableLoading = false;
            }, 500);
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.renderDayChart();
            this.queryDayData();
        });
    },
    beforeDestroy() {
        [this.dayChart, this.monthChart, this.personChart].forEach((chart) => {
            if (chart) chart.dispose();
        });
    }
};
</script>

<style lang="scss" scoped>
.visit-statistics-container {
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    box-sizing: border-box;

    .statistics-card {
        width: 100%;
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;

        h2 {
            margin: 0;
            font-size: 22px;
            color: #333;
            font-weight: 600;
        }

        .header-right {
            display: flex;
            align-items: center;
            gap: 10px;
        }
    }

    .custom-tabs {
        ::v-deep .el-tabs__nav {
            border-bottom: 1px solid #ebeef5;
        }
        ::v-deep .el-tabs__item {
            font-size: 14px;
            color: #666;
            padding: 0 20px;
        }
        ::v-deep .el-tabs__item.is-active {
            color: #406abb;
            font-weight: 600;
            border-bottom: 2px solid #406abb;
        }
        ::v-deep .el-tabs__content {
            margin-top: 15px;
        }
    }

    .chart-wrapper {
        margin-bottom: 15px;
        padding: 10px 15px;
        background: #fff;
        border: 1px solid #ebeef5;
        border-radius: 4px;

        h4 {
            margin: 0 0 10px 0;
            font-size: 15px;
            color: #333;
            font-weight: 600;
        }
    }

    .fixed-table-container {
        width: 100%;
        border-radius: 4px;
        overflow: hidden;
        border: 1px solid #ebeef5;

        ::v-deep .el-table {
            --el-table-border-color: #ebeef5;
            --el-table-header-text-color: #333;
        }
        ::v-deep .el-table__row:hover {
            background-color: inherit !important;
        }
    }

    .pagination {
        margin-top: 15px;
        text-align: center;

        ::v-deep .el-pagination__page {
            min-width: 30px;
            height: 30px;
            line-height: 30px;
        }
        ::v-deep .el-pagination__page.is-active {
            background-color: #406abb;
            color: #fff;
        }
    }
}
</style>
